"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ToastType;
(function (ToastType) {
    ToastType["Error"] = "error";
    ToastType["Info"] = "info";
})(ToastType = exports.ToastType || (exports.ToastType = {}));
//# sourceMappingURL=index.js.map